import React from 'react';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/Button.jsx";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";

function Transition(props) {
    return <Slide direction="down" {...props} />;
  }

class SmallModal extends React.Component {
    render() {

        const { classes }  = this.props;

        return (
            <Dialog
                classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal + " " + classes.modalSmall
                }}
                open={this.props.isOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.props.close}
                aria-labelledby="small-modal-slide-title"
                aria-describedby="small-modal-slide-description"
            >
                <DialogTitle
                    id="small-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={this.props.close}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                </DialogTitle>
                <DialogContent
                    id="small-modal-slide-description"
                    className={
                        classes.modalBody + " " + classes.modalSmallBody
                    }
                >
                    <h5>{this.props.children}</h5>
                </DialogContent>
                <DialogActions
                    className={
                        classes.modalFooter +
                        " " +
                        classes.modalFooterCenter
                    }
                >
                    <Button
                        onClick={this.props.close}
                        color="transparent"
                        className={classes.modalSmallFooterFirstButton}
                    >
                        Never Mind
                          </Button>
                    <Button
                        onClick={this.props.accept}
                        color="success"
                        simple
                        className={
                            classes.modalSmallFooterFirstButton +
                            " " +
                            classes.modalSmallFooterSecondButton
                        }
                    >
                        Yes
                          </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(notificationsStyle)(SmallModal);